module.exports = __webpack_public_path__ + "static/img/moduloBidirecional-1.5fd95c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/moduloBidirecional-1.svg
// module id = GQ7r
// module chunks = 0